module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r2n7n4n-b8bfa6f2639c78525423058909b4d7ec.svg";